import {
  Card,
  ECardBorderRadiusSize,
  ECardMediaSize,
  EIconButtonVariant,
  GeneralSearchIcon,
  IconButton,
} from '@outdoorsyco/bonfire';
import React, { useState } from 'react';

import MaxWidth from '@/components/common/layout/MaxWidth';
import CampgroundAmenitiesContainer from '@/components/route/listing/Amenities/CampgroundAmenitiesContainer';
import GalleryItem from '@/components/route/listing/Gallery/GalleryList/GalleryItem';
import lightBoxCSS from '@/components/route/listing/Gallery/GalleryList/GalleryList.module.css';
import Lightbox from '@/components/switchback/Lightbox';
import { useBreakpoint } from '@/hooks/useBreakpoint';
interface IProps {
  siteMapImageURL: string;
}

export const AmenitiesAndSiteMap: React.FC<IProps> = ({ siteMapImageURL }) => {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const { isMobile } = useBreakpoint();

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };
  const openLightbox = () => {
    setIsLightboxOpen(true);
  };
  return (
    <section className="py-8 md:py-12">
      <MaxWidth className="mx-auto md:flex-row gap-12">
        <div className="flex flex-col flex-1 gap-8">
          <CampgroundAmenitiesContainer isEscapes />
        </div>
        {siteMapImageURL && (
          <div className="flex-1">
            <Card borderRadiusSize={ECardBorderRadiusSize.Large} withBoxShadow className="relative">
              <Card.Media
                image={siteMapImageURL}
                size={ECardMediaSize.Full}
                className="rounded-2xl overflow-clip"
              />
              <IconButton
                icon={GeneralSearchIcon}
                onClick={openLightbox}
                variant={EIconButtonVariant.Primary}
                size={isMobile ? 'small' : 'medium'}
                className="absolute bottom-4 right-4 !bg-canvas-300"
              />
            </Card>
            <div className={lightBoxCSS.wrapper}>
              <Lightbox
                infinite
                dots={false}
                adaptiveHeight
                lazyLoad="ondemand"
                customModalClass={lightBoxCSS.lightBoxModal}
                className={lightBoxCSS.lightBox}
                open={isLightboxOpen}
                onClose={closeLightbox}>
                <GalleryItem image={siteMapImageURL} isVideo={false} index={0} />
              </Lightbox>
            </div>
          </div>
        )}
      </MaxWidth>
    </section>
  );
};
